'use client'

import { Box, Stack, Typography, useTheme } from '@mui/material'
import classNames from 'classnames'
import ResponsiveImage from '../responsiveImage/responsiveImage'
import { StyledResource } from './resource.styles'
import { Button } from '../button/button'

export const Resource = ({
  href,
  cta = 'Download',
  children,
  external,
  prompt,
  title,
  desc,
  img,
  alt,
  icon,
  trackingId,
  sources,
  priority,
  ...props
}) => {
  const theme = useTheme()

  return (
    <StyledResource
      {...props}
      className="stack"
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      alignSelf={{ sm: 'center' }}
    >
      <Box sx={{ width: '100%', maxWidth: { xs: 'unset', md: '270px' } }}>
        <ResponsiveImage
          sx={{ width: '100%' }}
          src={img}
          alt={alt}
          sources={sources}
          priority={priority}
        />
      </Box>
      <Stack
        className="text"
        direction="column"
        justifyContent="center"
        alignContent="center"
      >
        <Typography
          color="tertiary.main"
          fontWeight={theme.typography.fontWeightBold}
        >
          {title}
        </Typography>
        <Typography>{desc}</Typography>
        <Stack direction="column" spacing={2} width="fit-content">
          <Button
            fontWeight={700}
            href={href}
            target="_blank"
            className={classNames('blue')}
            external={external}
            prompt={prompt}
            icon={icon}
            trackingId={trackingId}
            aria-label={title ? `${cta}: ${title}` : undefined}
            sx={{ width: '100%' }}
          >
            {cta}
          </Button>
          {children}
        </Stack>
      </Stack>
    </StyledResource>
  )
}
